import { gateway } from "../../../../../../gateway";

export interface SyncInvoicePaymentResponse {
  status: number;
  message: string;
  data?: { synced: boolean; paidAt: string | null };
}

type Token = string | null | undefined;

/**
 * Ask backend to sync payment status from PayPal (fallback when webhook was missed).
 * Uses same auth as getInvoice (link token or localStorage token).
 */
export const syncInvoicePayment = async (invoiceUid: string, token?: Token): Promise<SyncInvoicePaymentResponse["data"]> => {
  const authToken = token ?? sessionStorage.getItem("token");
  const response = await gateway.post<SyncInvoicePaymentResponse>(
    `/invoices/${invoiceUid}/sync-payment`,
    {},
    {
      headers: authToken ? { Authorization: `Bearer ${authToken}` } : {},
    },
  );
  return response.data?.data;
};
